import React, { FunctionComponent, useState } from "react"
import lodash from "lodash"
import { useFormContext } from "react-hook-form"

import Pill from "./index"
import "./../../base/grid.scss"
import "./styles.scss"

interface Props {
  legendText: string
  onGroupChange: Function
  pillGroupName: string
  pillText: string
}

const PillFieldsetGroup: FunctionComponent<Props> = ({
  legendText,
  onGroupChange,
  pillGroupName,
  pillText
}) => {
  const [currentInputSelected, setCurrentInputSelected] = useState<string | null>(
    pillText.toLowerCase()
  )
  const { errors } = useFormContext()

  const fieldError = lodash.get(errors, pillGroupName)
  let isFieldValid
  if (fieldError && fieldError.type === "required") {
    isFieldValid = true
  } else {
    isFieldValid = false
  }

  const handleChange = (
    inputValue: string,
    type: string,
    event: React.SyntheticEvent
  ) => {
    onGroupChange(inputValue, type)
    setCurrentInputSelected(inputValue)
  }
  return (
    <React.Fragment>
      <div className="grid-wrapper">
        <legend className="span-two-col">{legendText}</legend>
        <div className="span-two-col">
          <Pill
            key={`${pillGroupName}-n/a`}
            pillGroupName={pillGroupName}
            text="N/A"
            labelId="n/a"
            type="n/a"
            currentPillTextSelected={currentInputSelected}
            onPillChange={handleChange}
          />
          <Pill
            key={`${pillGroupName}-possibly`}
            pillGroupName={pillGroupName}
            text="Possibly"
            labelId="possibly"
            type="possibly"
            currentPillTextSelected={currentInputSelected}
            onPillChange={handleChange}
          />
          <Pill
            key={`${pillGroupName}-applicable`}
            pillGroupName={pillGroupName}
            text="Applicable"
            labelId="applicable"
            type="applicable"
            currentPillTextSelected={currentInputSelected}
            onPillChange={handleChange}
          />
        </div>
        {isFieldValid && (
          <span className="validation-error">
            Please select institutional impact
          </span>
        )}
      </div>
    </React.Fragment>
  )
}
export default PillFieldsetGroup
